<script>
  import { format } from 'svelte-i18n';
  import { Card, CardBody } from '@sveltestrap/sveltestrap';

  import { SwitchField, TextareaField } from '@client/components/fields/standalone';

  import { disabledValue, enabledValue } from '@client/pages/manage/domain-settings';

  import { markdown } from '@client/utils/markdown';

  const formatFAQ = (val) => markdown(val);

  export let settings = {};
  export let onUpdate = null;

  $: mysigUrl = `https://${settings.cnames.slice().pop()}/mysig`;
</script>

<div id="signature">
  <h1 class="mb-3">{$format('label.GENERAL')}</h1>

  <Card>
    <CardBody class="p-4 pt-1">
      <SwitchField
        id="enablemysignature"
        label={$format('label.MY_SIGNATURE')}
        tooltip={$format('label.TOOLTIP.MY_SIGNATURE')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        bind:checked={settings.enablemysignature}
        {onUpdate}
      />

      <SwitchField
        id="mysigui-disablesigblock"
        label={$format('label.SIGNATURE_BLOCK_COPY')}
        tooltip={$format('label.TOOLTIP.SIGNATURE_BLOCK_COPY', { values: { url: mysigUrl } })}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        inverted
        bind:checked={settings.mysigui.disablesigblock}
        {onUpdate}
      />

      <SwitchField
        id="mysigui-enablebannerblock"
        label={$format('label.BANNER_BLOCK_COPY')}
        tooltip={$format('label.TOOLTIP.BANNER_BLOCK_COPY', { values: { url: mysigUrl } })}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        bind:checked={settings.mysigui.enablebannerblock}
        {onUpdate}
      />

      <SwitchField
        id="hidemysiglink"
        label={$format('label.MY_SIGNATURE_LINK')}
        tooltip={$format('label.TOOLTIP.MY_SIGNATURE_LINK')}
        valueOn={$format(enabledValue)}
        valueOff={$format(disabledValue)}
        inverted
        bind:checked={settings.hidemysiglink}
        {onUpdate}
      />

      <TextareaField
        id="mysigui-note"
        label={$format('label.HELP_TEXT')}
        tooltip={$format('label.TOOLTIP.HELP_TEXT', { values: { url: mysigUrl } })}
        bind:value={settings.mysigui.note}
        {onUpdate}
        allowCopy
      />

      <TextareaField
        id="mysigui-bannernote"
        label={$format('label.BANNER_BLOCK_HELP_TEXT')}
        tooltip={$format('label.TOOLTIP.BANNER_BLOCK_HELP_TEXT', { values: { url: mysigUrl } })}
        bind:value={settings.mysigui.bannernote}
        {onUpdate}
        allowCopy
      />

      <TextareaField
        id="mysigui-bannerinstructions"
        label={$format('label.BANNER_BLOCK_DESCRIPTION_TEXT')}
        tooltip={$format('label.TOOLTIP.BANNER_BLOCK_DESCRIPTION_TEXT', { values: { url: mysigUrl } })}
        bind:value={settings.mysigui.bannerinstructions}
        {onUpdate}
        allowCopy
      />

      <TextareaField
        id="mysigui-faq"
        label={$format('label.CUSTOM_FAQ_SECTION')}
        tooltip={$format('label.TOOLTIP.CUSTOM_FAQ_SECTION')}
        formatValue={() => ' '}
        bind:value={settings.mysigui.faq}
        {onUpdate}
        allowCopy
      >
        {#if settings.mysigui?.faq?.length}
          <p>
            {$format('label.DESCRIPTION.CUSTOM_FAQ_SECTION')}
            <a href={mysigUrl} target="_blank" rel="noreferrer">{mysigUrl}</a>
          </p>
          <div class="faq">
            {@html formatFAQ(settings.mysigui.faq)}
          </div>
        {/if}
      </TextareaField>
    </CardBody>
  </Card>
</div>

<style lang="scss" src="./signature.scss"></style>
